/* GMapRulerBuilder -- builds ruler for Google Map */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.returnExports = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {

  var DOT_CSS = 'position:absolute;width:10px;height:10px;background:#fff;border:2px solid #444;border-radius:50%;box-sizing:border-box;transform:translate(-50%,-50%);pointer-events:none;';

  function makeDiv() {
    var div = document.createElement('div');
    div.style.cssText = DOT_CSS;
    return div;
  }

  function DotMarker(latLng, map) {
    this.latLng_ = latLng;
    this.divs_ = [];
    this._clickCallback = null;
    this.setMap(map);
  }
  DotMarker.prototype = Object.create(google.maps.OverlayView.prototype);
  DotMarker.prototype.constructor = DotMarker;
  DotMarker.prototype.onAdd = function () {
    var div = makeDiv();
    this.divs_ = [div];
    this.getPanes().overlayMouseTarget.appendChild(div);
    if (this._clickCallback) {
      this._applyClickHandlerToDiv(div);
    }
  };
  DotMarker.prototype.draw = function () {
    if (this.divs_.length === 0) { return; }
    var point = this.getProjection().fromLatLngToDivPixel(this.latLng_);
    if (!point) { return; }
    var map = this.getMap();
    var zoom = map ? map.getZoom() : undefined;
    var mapDiv = map ? map.getDiv() : null;
    var panes = this.getPanes();
    if (zoom === undefined || !mapDiv || !panes) {
      this.divs_[0].style.left = point.x + 'px';
      this.divs_[0].style.top = point.y + 'px';
      for (var h = 1; h < this.divs_.length; h++) { this.divs_[h].style.display = 'none'; }
      return;
    }
    var worldWidthPx = 256 * Math.pow(2, zoom);
    var containerWidth = mapDiv.getBoundingClientRect().width;
    if (containerWidth <= 0 || worldWidthPx <= 0) {
      this.divs_[0].style.left = point.x + 'px';
      this.divs_[0].style.top = point.y + 'px';
      return;
    }
    // Use container-pixel coordinates for visibility check (viewport intersection).
    // Container-pixel origin is always at the map container's top-left corner,
    // so visible points always have x in [0, containerWidth] regardless of pan state.
    var containerPoint = this.getProjection().fromLatLngToContainerPixel(this.latLng_);
    var cpx = containerPoint ? containerPoint.x : point.x;

    var xs = [];
    var startN = Math.floor(-cpx / worldWidthPx);
    var endN = Math.ceil((containerWidth - cpx) / worldWidthPx);
    for (var n = startN; n <= endN; n++) {
      var containerX = cpx + n * worldWidthPx;
      if (containerX >= -5 && containerX <= containerWidth + 5) {
        // Position uses DIV coordinates (required for overlay pane positioning)
        xs.push(point.x + n * worldWidthPx);
      }
    }
    if (xs.length === 0) { xs.push(point.x); }
    var self = this;
    while (this.divs_.length < xs.length) {
      var newDiv = makeDiv();
      panes.overlayMouseTarget.appendChild(newDiv);
      if (self._clickCallback) { self._applyClickHandlerToDiv(newDiv); }
      self.divs_.push(newDiv);
    }
    for (var i = 0; i < this.divs_.length; i++) {
      if (i < xs.length) {
        this.divs_[i].style.display = '';
        this.divs_[i].style.left = xs[i] + 'px';
        this.divs_[i].style.top = point.y + 'px';
      } else {
        this.divs_[i].style.display = 'none';
      }
    }
  };
  DotMarker.prototype.onRemove = function () {
    this.divs_.forEach(function (div) {
      if (div.parentNode) { div.parentNode.removeChild(div); }
    });
    this.divs_ = [];
  };
  DotMarker.prototype.setPosition = function (latLng) {
    this.latLng_ = latLng;
    this.draw();
  };
  DotMarker.prototype.setClickable = function (callback) {
    var self = this;
    self._clickCallback = callback || null;
    self.divs_.forEach(function (div) { self._applyClickHandlerToDiv(div); });
  };
  DotMarker.prototype._applyClickHandlerToDiv = function (div) {
    var self = this;
    div.onclick = null;
    if (self._clickCallback) {
      div.style.pointerEvents = 'auto';
      div.style.cursor = 'pointer';
      div.onclick = function (e) {
        e.stopPropagation();
        self._clickCallback();
      };
    } else {
      div.style.pointerEvents = 'none';
      div.style.cursor = '';
    }
  };

  function isClickOnMapControl(e) {
    var controls = document.querySelectorAll('.map_selector, .map_ruler, .map_delete_rectangle');
    for (var i = 0; i < controls.length; i++) {
      var rect = controls[i].getBoundingClientRect();
      if (e.clientX >= rect.left && e.clientX <= rect.right &&
          e.clientY >= rect.top && e.clientY <= rect.bottom) {
        return true;
      }
    }
    return false;
  }

  function GMapRuler(gMap, activationCallback) {
    this.POLYLINE_OPTIONS = {
      strokeColor: '#000000',
      strokeWeight: 2,
      zIndex: 1000000
    };
    this.ruler = null;
    this.endLabelMarker = null;
    this.gMap = gMap;
    this.activationCallback = activationCallback || null;

    this.inMeasuringState = false;
    this.rulerFinished = true;
    this.vertexDots = [];
    this.pathListeners = null;

    this.mapRulerButton = null;
    this.clickListener = null;
    this.dblClickListener = null;
    this.mousemoveListener = null;
    this.keydownListener = null;
    this.previewPolyline = null;

    this._captureDiv = null;
    this._captureDivClickHandler = null;
    this._captureDivMousemoveHandler = null;
    this._captureDivDblClickHandler = null;
  }

  GMapRuler.prototype.addDrawingUi = function (container) {
    var self = this;

    self.endLabelMarker = new MarkerWithLabel({
      position: new google.maps.LatLng(0, 0),
      icon: GMapUtil.generateMarkerImage(GMapUtil.imageUrlDot(), 1),
      shape: {
        coords: [0.5, 0.5, 0.5],
        type: 'circle'
      },
      labelAnchor: new google.maps.Point(-10, 5),
      labelStyle: {
        'font-weight': 'bold',
        'background-color': '#FFFFFF',
        'opacity': '0.8',
        'padding': '2px',
        'z-index': '1000000'
      }
    });

    var mapRulerControl = $.parseHTML("<div class='map_ruler'></div>");
    $(mapRulerControl[0]).prop('title', I18n.t('globals.gmap.ruler_icon_tooltip'));
    mapRulerControl[0].addEventListener('click', function () {
      self.onRulerControlClick();
    });

    self.mapRulerButton = $.parseHTML("<div id='map_ruler_button'>" + GMapUtil.imageTagRuler() + "</div>");
    mapRulerControl[0].appendChild(self.mapRulerButton[0]);

    if (container) {
      container.appendChild(mapRulerControl[0]);
    } else {
      var mapCenterControl = $.parseHTML("<div></div>");
      mapCenterControl[0].index = -1;
      mapCenterControl[0].appendChild(mapRulerControl[0]);
      this.gMap.map().controls[google.maps.ControlPosition.LEFT_CENTER].push(mapCenterControl[0]);
    }
  };

  GMapRuler.prototype.onRulerControlClick = function () {
    var self = this;
    if (self.inMeasuringState) {
      if (self.rulerFinished) {
        self.toggleRulerOff();
      } else {
        self.finishRuler();
        if (!self.ruler) {
          self.toggleRulerOff();
        }
      }
    } else {
      self.toggleOnAndStartRuler();
    }
  };

  GMapRuler.prototype.toggleRulerOff = function () {
    var self = this;
    self.inMeasuringState = false;
    self.mapRulerButton[0].classList.remove('showing');
    self.gMap.map().setOptions({ draggableCursor: null, draggable: true, gestureHandling: 'auto' });

    if (self.keydownListener) {
      document.removeEventListener('keydown', self.keydownListener);
      self.keydownListener = null;
    }

    self.removeDrawingListeners();
    self.removePathListeners();

    if (self.ruler) {
      self.ruler.setMap(null);
      self.ruler = null;
    }
    if (self.endLabelMarker) {
      self.endLabelMarker.setMap(null);
    }
    self.removeVertexDots();
  };

  GMapRuler.prototype.toggleOnAndStartRuler = function () {
    var self = this;

    if (self.activationCallback) {
      self.activationCallback();
    }

    self.inMeasuringState = true;
    self.mapRulerButton[0].classList.add('showing');
    self.rulerFinished = false;
    self.gMap.map().setOptions({ draggableCursor: 'crosshair', draggable: false, gestureHandling: 'greedy' });

    self.keydownListener = function (e) {
      if (e.key === 'Delete' || e.key === 'Backspace') {
        self.toggleRulerOff();
      }
    };
    document.addEventListener('keydown', self.keydownListener);

    self.clickListener = google.maps.event.addListener(self.gMap.map(), 'click', function (event) {
      self.onMapClick(event.latLng);
    });

    self.mousemoveListener = google.maps.event.addListener(self.gMap.map(), 'mousemove', function (event) {
      if (!self.ruler || self.rulerFinished) { return; }
      var path = self.ruler.getPath();
      if (path.getLength() < 1) { return; }
      if (!self.previewPolyline) {
        self.previewPolyline = new google.maps.Polyline($.extend({}, self.POLYLINE_OPTIONS, {
          map: self.gMap.map(),
          strokeOpacity: 0.5,
          clickable: false
        }));
      }
      self.previewPolyline.setPath([path.getAt(path.getLength() - 1), event.latLng]);
    });

    self.dblClickListener = google.maps.event.addListener(self.gMap.map(), 'dblclick', function () {
      // Both click events fire before dblclick fires, so remove the extra point
      if (self.ruler) {
        var path = self.ruler.getPath();
        if (path.getLength() > 1) {
          path.pop();
          self.removeLastVertexDot();
        }
        if (path.getLength() >= 2) {
          self.updateLabel();
        }
      }
      self.finishRuler();
    });

    // Capture overlay: sits above all map overlays (z-index 9999) so drawing clicks
    // register even when the cursor is over the finished rectangle or other overlays.
    var mapDiv = self.gMap.map().getDiv ? self.gMap.map().getDiv() : null;
    if (mapDiv) {
      var captureDiv = document.createElement('div');
      captureDiv.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:9999;cursor:crosshair;';
      mapDiv.appendChild(captureDiv);
      self._captureDiv = captureDiv;

      function eventToLatLng(e) {
        var projection = self.gMap.map().getProjection();
        var center = projection.fromLatLngToPoint(self.gMap.map().getCenter());
        var scale = Math.pow(2, self.gMap.map().getZoom());
        var mapRect = mapDiv.getBoundingClientRect();
        var x = Math.max(0, Math.min(e.clientX - mapRect.left, mapRect.width));
        var y = Math.max(0, Math.min(e.clientY - mapRect.top, mapRect.height));
        var worldPoint = new google.maps.Point(
          center.x + (x - mapRect.width  / 2) / scale,
          center.y + (y - mapRect.height / 2) / scale
        );
        return projection.fromPointToLatLng(worldPoint);
      }

      self._captureDivClickHandler = function (e) {
        if (isClickOnMapControl(e)) { return; }
        // If the last vertex dot is under the cursor, finish the ruler — the dot's
        // own onclick is shadowed by captureDiv, so we replicate its behavior here.
        var lastDot = self.vertexDots.length > 0 ? self.vertexDots[self.vertexDots.length - 1] : null;
        if (lastDot) {
          var underCursor = document.elementsFromPoint(e.clientX, e.clientY);
          var dotDivs = lastDot.divs_ || [];
          if (dotDivs.some(function (div) { return underCursor.indexOf(div) !== -1; })) {
            self.finishRuler();
            if (!self.ruler) { self.toggleRulerOff(); }
            return;
          }
        }
        google.maps.event.trigger(self.gMap.map(), 'click', { latLng: eventToLatLng(e) });
      };

      self._captureDivMousemoveHandler = function (e) {
        google.maps.event.trigger(self.gMap.map(), 'mousemove', { latLng: eventToLatLng(e) });
      };

      self._captureDivDblClickHandler = function (e) {
        if (isClickOnMapControl(e)) { return; }
        google.maps.event.trigger(self.gMap.map(), 'dblclick');
      };

      captureDiv.addEventListener('click', self._captureDivClickHandler);
      captureDiv.addEventListener('mousemove', self._captureDivMousemoveHandler);
      captureDiv.addEventListener('dblclick', self._captureDivDblClickHandler);
    }
  };

  GMapRuler.prototype.onMapClick = function (latLng) {
    var self = this;
    if (!self.ruler) {
      self.ruler = new google.maps.Polyline($.extend({}, self.POLYLINE_OPTIONS, { map: self.gMap.map() }));
    }
    self.ruler.getPath().push(latLng);
    self.addVertexDot(latLng);
    if (self.ruler.getPath().getLength() >= 2) {
      self.updateLabel();
    }
  };

  GMapRuler.prototype.addVertexDot = function (latLng) {
    var self = this;
    // Previous last dot is no longer the last — clear its click handler
    if (self.vertexDots.length > 0) {
      self.vertexDots[self.vertexDots.length - 1].setClickable(null);
    }
    var dot = new DotMarker(latLng, self.gMap.map());
    dot.setClickable(function () {
      self.finishRuler();
      if (!self.ruler) {
        self.toggleRulerOff();
      }
    });
    self.vertexDots.push(dot);
  };

  GMapRuler.prototype.removeLastVertexDot = function () {
    var self = this;
    var dot = self.vertexDots.pop();
    if (dot) {
      dot.setMap(null);
    }
    // Restore click handler on new last dot
    if (self.vertexDots.length > 0) {
      self.vertexDots[self.vertexDots.length - 1].setClickable(function () {
        self.finishRuler();
        if (!self.ruler) {
          self.toggleRulerOff();
        }
      });
    }
  };

  GMapRuler.prototype.removeVertexDots = function () {
    this.vertexDots.forEach(function (dot) { dot.setMap(null); });
    this.vertexDots = [];
  };

  GMapRuler.prototype.finishRuler = function () {
    var self = this;
    if (!self.ruler) { return; }
    self.rulerFinished = true;
    self.gMap.map().setOptions({ draggable: true, gestureHandling: 'auto' });
    self.removeDrawingListeners();
    // Remove the custom dots used during drawing — Google Maps native handles take over
    self.removeVertexDots();
    // Enable native Google Maps vertex + midpoint editing handles
    self.ruler.setOptions({ editable: true, draggable: true });
    // Keep label updated when user drags vertices, midpoints, or the whole polyline
    var path = self.ruler.getPath();
    self.pathListeners = [
      google.maps.event.addListener(path, 'set_at', function () { self.updateLabel(); }),
      google.maps.event.addListener(path, 'insert_at', function () { self.updateLabel(); }),
      google.maps.event.addListener(path, 'remove_at', function () { self.updateLabel(); }),
      google.maps.event.addListener(self.ruler, 'dragend', function () { self.updateLabel(); }),
    ];
  };

  GMapRuler.prototype.removePathListeners = function () {
    if (this.pathListeners) {
      this.pathListeners.forEach(function (l) { google.maps.event.removeListener(l); });
      this.pathListeners = null;
    }
  };

  GMapRuler.prototype.removeDrawingListeners = function () {
    var self = this;
    if (self._captureDiv) {
      if (self._captureDivClickHandler) { self._captureDiv.removeEventListener('click', self._captureDivClickHandler); }
      if (self._captureDivMousemoveHandler) { self._captureDiv.removeEventListener('mousemove', self._captureDivMousemoveHandler); }
      if (self._captureDivDblClickHandler) { self._captureDiv.removeEventListener('dblclick', self._captureDivDblClickHandler); }
      if (self._captureDiv.parentNode) { self._captureDiv.parentNode.removeChild(self._captureDiv); }
      self._captureDiv = null;
    }
    self._captureDivClickHandler = null;
    self._captureDivMousemoveHandler = null;
    self._captureDivDblClickHandler = null;
    if (self.clickListener) {
      google.maps.event.removeListener(self.clickListener);
      self.clickListener = null;
    }
    if (self.dblClickListener) {
      google.maps.event.removeListener(self.dblClickListener);
      self.dblClickListener = null;
    }
    if (self.mousemoveListener) {
      google.maps.event.removeListener(self.mousemoveListener);
      self.mousemoveListener = null;
    }
    if (self.previewPolyline) {
      self.previewPolyline.setMap(null);
      self.previewPolyline = null;
    }
  };

  GMapRuler.prototype.updateLabel = function () {
    if (!this.ruler) { return; }
    var path = this.ruler.getPath();
    var distance = google.maps.geometry.spherical.computeLength(path.getArray());
    var labelText = roundDistanceWithUnits(distance, window.useImperialUnits);

    if (path.getLength() === 2) {
      var azimuth = google.maps.geometry.spherical.computeHeading(path.getAt(0), path.getAt(1));
      labelText += ', ' + formatAndRoundAzimuth(azimuth);
    }

    this.endLabelMarker.setPosition(path.getAt(path.getLength() - 1));
    this.endLabelMarker.set('labelContent', labelText);
    this.endLabelMarker.setMap(this.gMap.map());
  };

  var SHORT_DISTANCE_THRESHOLD = 1000;
  var DIGITS = 2;

  function roundDistanceWithUnits(distance, useImperialUnits) {
    if (distance < SHORT_DISTANCE_THRESHOLD) {
      return useImperialUnits ? Util.convertMetresToFeet(distance).toFixed(DIGITS) + '&nbsp;ft' : distance.toFixed(DIGITS) + '&nbsp;m';
    } else {
      return useImperialUnits ? Util.convertMetresToMiles(distance).toFixed(DIGITS) + '&nbsp;mi' : Util.convertMetresToKilometres(distance).toFixed(DIGITS) + '&nbsp;km';
    }
  }

  function formatAndRoundAzimuth(azimuth) {
    if (azimuth < 0) {
      azimuth = azimuth + 360;
    }
    return azimuth.toFixed(DIGITS) + '°';
  }

  return function (gMap, activationCallback, container) {
    if (!gMap.map()) {
      throw new Error("gMap must be initialized (setupMap called) before adding the selector controls");
    }
    var gMapRuler = new GMapRuler(gMap, activationCallback);
    gMapRuler.addDrawingUi(container);
    return gMapRuler;
  };
}));
